export const Monate: {label: string, value: number}[] = [
    {label: 'Jänner', value: 1 },
    {label: 'Februar', value: 2},
    {label: 'März', value: 3},
    {label: 'April', value: 4},
    {label: 'Mai', value: 5},
    {label: 'Juni', value: 6 },
    {label: 'Juli', value: 7 },
    {label: 'August', value: 8},
    {label: 'September', value: 9},
    {label: 'Oktober', value: 10},
    {label: 'November', value: 11},
    {label: 'Dezember', value: 12},
];
